module.exports = __webpack_public_path__ + "static/media/lanabatyrova.c04fd230.png";